// removed by extract-text-webpack-plugin
module.exports = {"aivfInfoContainer":"aivfInfoContainer__2LWz_","aivfInfoHeaderContainer":"aivfInfoHeaderContainer__1Nx7q","aivfHeaderText":"aivfHeaderText__3QOms","aivfInfoBodyContainer":"aivfInfoBodyContainer__1mxn8","bodyContainer":"bodyContainer__2VEp1","purchaseButtonContainer":"purchaseButtonContainer__zROBD","cardInfoText":"cardInfoText__17tNR","cardInfoContainer":"cardInfoContainer__K_uqu","cardInfoTextContainer":"cardInfoTextContainer__oo4LP","leftImageContainer":"leftImageContainer__1_fSd","buttonContainer":"buttonContainer__1QxqG"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/modals/aivfInfoModal/style.css
// module id = aGVp
// module chunks = 307